import { Component, inject } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { KENDO_GRID } from '@progress/kendo-angular-grid';
import { AbstractGridComponent } from '@unity/abstract/abstract-grid.component';
import { ProgramDetailedDto, ProgramsClient } from '@unity/clients';
import { TypedDirective } from '@unity/directives/typed.directive';
import { GridSharedComponent } from '@unity/shared/composed/grid-shared/grid-shared.component';
import { ChipWorkflowStateSharedComponent } from '@unity/shared/presentation/chip-workflow-state-shared/chip-workflow-state-shared.component';
import { GridcellCurrencySharedComponent } from '@unity/shared/presentation/gridcell-currency-shared/gridcell-currency-shared.component';
import { LinkGridcellSharedComponent } from '@unity/shared/presentation/link-gridcell-shared/link-gridcell-shared.component';
import { SortConfig } from '@unity/utils/types';

@Component({
  selector: 'unity-grid-program-shared',
  standalone: true,
  imports: [
    KENDO_GRID,
    GridSharedComponent,
    LinkGridcellSharedComponent,
    GridcellCurrencySharedComponent,
    ChipWorkflowStateSharedComponent,
    TypedDirective,
  ],
  templateUrl: './grid-program-shared.component.html',
  styleUrl: './grid-program-shared.component.scss',
})
export class GridProgramSharedComponent extends AbstractGridComponent<ProgramDetailedDto> {
  private readonly programsClient = inject(ProgramsClient);

  protected resource = rxResource({
    params: () => {
      const query = this.$gridifyQuery();
      return query ? { query } : undefined;
    },
    stream: ({ params: { query } }) => this.programsClient.getAllAsDetailed(query.page, query.pageSize, query.orderBy, query.filter),
  });

  protected defaultSort: SortConfig[] = [
    {
      field: 'created_dt',
      dir: 'desc',
    },
  ];
}
